export default __webpack_public_path__ + "static/media/h1b2.ac7b3969.png";